import Rollbar from 'rollbar';
import environmentVariables from './utils/get-environment-variables';

const _RollbarConfig = {
  enabled: (!!process.env.NODE_ENV && process.env.NODE_ENV !== 'development'),
  accessToken: environmentVariables.REACT_APP_ROLLBAR_ACCESS_TOKEN || 'a1b4731d8b4d4728b7ebb3595de4a2dd',
  captureUncaught: true,
  captureUnhandledRejections: false,
  payload: {
    environment: environmentVariables.REACT_APP_HEROKU_PIPELINE_ENV || 'development',
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
        code_version: process.env.REACT_APP_HEROKU_SLUG_COMMIT,
      },
    },
  },
};

const rollbar = new Rollbar(_RollbarConfig);

function rollbarConfigUser(user) {
//   rollbar.configure({ payload: { business: {
//     name: (user && user.name) || '',
//     href: (user && user.href) || '',
//   } } });
console.log('insode rollllllllllbarrrrrrrr', user);
  rollbar.configure({
    payload: {
      person: {
        id: user.id || '',
        username: user.name || '',
        email: user.email || '',
      }
    }
  });
}

export {
  rollbar,
  rollbarConfigUser,
};
